<template>
  <div class="recruit">
    <div class="recruitment">
        <indexTitle>
            <template v-slot:title>
            师资队伍
        </template>
        <template v-slot:eng>
            Faculty Team
        </template>
        <template v-slot:more>
            <a @click="$router.push({ path: '/alumnus', query: { subtitle: 'sztd' } })">更多</a>
        </template>
        </indexTitle>
        <ul class="row">
            <li class="detail" v-for="(item, idx) in staffList" :key="idx">
                <a
                href="javascript:;"
                class="rczp-list-link"
                @click="$router.push({ path: '/alumnus/detail', query: { subtitle: 'sztd', id: item.id } })"
                >
                <div class="head-img">
                    <img :src="$baseUrl + item.imageUrl" alt="头像">
                </div>
                <div class="name">{{ item.title }}</div>
                </a>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
import { getAlumnus } from '@/api/alumnus.js'

export default {
  name: 'indexAlumnus',
  data () {
    return {
      staffList: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      try {
        const res = await getAlumnus({
          page: 1,
          pageSize: 10
        })
        if (res.code === 1 && res.data?.rows) {
          this.staffList = res.data.rows
        }
      } catch (err) {
        console.error('获取成员失败', err)
      }
    }
  }
}
</script>

<style lang="less">
.recruit{
    position:relative;
    padding:0 0 53px 0;
    background: #F4F7FC;
    &::before {
        position: absolute;
        content: "";
        left: 0;
        right: 232px;
        top: 0;
        bottom: 53px;
        min-height: 219px;
        background: url('@/assets/xuexiao.jpg') no-repeat top left;
        background-size: cover;
        background-attachment: fixed;
        border-radius: 0px 13.25px 13.25px 0px;
        z-index: 0;
    }
        .recruitment{
        padding:0 60px;
        position: relative;
        z-index: 1;
        .row{
            display: flex;
            flex-wrap: wrap;
            margin: 0 -4px;
        }
        .detail{
            position: relative;
            flex: 0 0 20%;
            max-width: 20%;
            padding:0 4px;
            margin-bottom: 20px;
            box-sizing: border-box;
            a{
                display: block;
                width: 100%;
                height: 238px;
                margin: 0 auto;
                box-shadow: rgba(14, 57, 98, 0.14) 2px 8px 18px 1px;
                position: relative;
                background: url(@/assets/bg31.png) right bottom / cover no-repeat rgb(255, 255, 255);
                border-radius: var(--radius-md);
                padding: 18px 0 0 0;
                overflow: hidden;
                transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.32s ease;
                &::before {
                    position: absolute;
                    content: "";
                    left: 0;
                    right: 0;
                    top: 0;
                    height: 2.65px;
                    background: #0E6BB6;
                }
                &:hover .name{
                    color:#0E6BB6;
                }
                &:hover{
                    transform: translateY(-10px);
                    box-shadow: 0 24px 48px rgba(10, 54, 92, 0.2);
                }
                /* 头像 */
                .head-img{
                width:100%;
                max-width:140px;
                aspect-ratio: 5 / 7;
                border-radius: var(--radius-sm);
                overflow:hidden;
                margin: 0 auto;
                img{
                    width: 100%;
                    height:100%;
                    object-fit:cover;
                }
                }
                /* 姓名 */
                .name{
                text-align:center;
                font-size:16px;
                font-weight: bold;
                color:#333;
                margin:10px 0 6px;
                }
                /* 虚线分割 */
                .desc-line{
                width:100%;
                border-bottom:1px dashed #cccccc;
                margin-bottom:10px;
                }
                /* 底部简介 */
                .desc{
                text-align:center;
                font-size:11px;
                color: #0E6BB6;
                line-height:1.6;
                overflow: hidden;
                }
            }
        }
    }
}
</style>
